module.exports = __webpack_public_path__ + "assets/candidate-links-logo.a2210fdd.png";